import React from 'react';

export default function PrivacyPolicy({ onClose }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(63, 197, 212, 0.24)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '90%',
          maxWidth: 460,
          background: 'linear-gradient(180deg, #4FC3D4 0%, #3AA8B8 100%)',
          borderRadius: 26,
          position: 'relative',
          padding: '40px 28px 28px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.23)',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
        onClick={e => e.stopPropagation()}
      >

        <button
          onClick={onClose}
          style={{
            border: 'none',
            background: 'rgba(255,255,255,0.32)',
            fontSize: 22,
            position: 'absolute',
            top: 22,
            right: 24,
            cursor: 'pointer',
            width: 36,
            height: 36,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 'bold',
            zIndex: 10,
          }}
        >
          ✕
        </button>

        <h2
          style={{
            margin: '0 0 20px 0',
            textAlign: 'center',
            color: '#fff',
            fontSize: 27,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            textShadow: '0 2px 6px rgba(0,0,0,0.18)',
          }}
        >
          • PRIVACY POLICY •
        </h2>

        <div
          style={{
            background: 'rgba(255,255,255,0.96)',
            borderRadius: 14,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            padding: '24px 17px',
            color: '#333',
            fontSize: 15,
            lineHeight: 1.75,
            marginTop: 2,
            marginBottom: 10
          }}
        >
          <div style={{ marginBottom: 8, fontSize: 14, opacity: 0.75 }}>
            Last updated: November 13, 2025
          </div>
          <p style={{ marginBottom: 15 }}>
            This Privacy Policy explains how MNWalk Idle collects, uses, and protects your personal information when you use our service. MNWalk Idle is operated by Limelight Labs.
          </p>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>1. Information We Collect</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>We may collect information you provide directly, such as account registration details, contact information, and feedback submitted through support channels.</li>
            <li>We also collect usage data, including log information, device identifiers, and approximate location based on IP address to help us maintain and improve the service.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>2. How We Use Information</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>We use the collected information to provide, maintain, and improve MNWalk Idle, personalize your experience, and communicate with you about updates or support matters.</li>
            <li>We may also use aggregated and anonymized data for analytics, research, and service optimization.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>3. Data Sharing</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>We do not sell your personal information. We may share information with trusted service providers who assist us in operating the service, subject to confidentiality obligations.</li>
            <li>We may disclose information if required by law or to protect our rights, users, or the public.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>4. Data Security</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>We implement reasonable administrative, technical, and physical safeguards to protect your information. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.</li>
            <li>In the event of a data incident, we will take appropriate steps to inform affected users and limit potential harm.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>5. Your Choices</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>You may review and update your account information through the user settings provided by the service.</li>
            <li>You can also contact us to request access, correction, or deletion of your personal information, subject to applicable legal requirements.</li>
          </ul>

          <h3 style={{fontWeight:700, color:'#3AA8B8', fontSize:17}}>6. Updates to This Policy</h3>
          <ul style={{marginLeft:19, marginBottom: 10}}>
            <li>We may revise this Privacy Policy from time to time. Significant changes will be posted on this page with an updated "Last updated" date.</li>
            <li>If you continue to use the service after changes take effect, you consent to the updated policy.</li>
          </ul>

          <div style={{ marginTop: 10 }}>
            If you have any questions about this Privacy Policy, please contact us at <a href="mailto:jwjpop@gmail.com" style={{color: "#3AA8B8"}}>jwjpop@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}
